import { abilityMod, modStr, type AbilityScores } from '@gm-binder/shared';
import styles from './StatBlock.module.css';

export interface StatBlockProps {
  abilities: AbilityScores;
}

const ORDER: { key: keyof AbilityScores; abbr: string }[] = [
  { key: 'strength', abbr: 'FOR' },
  { key: 'dexterity', abbr: 'DES' },
  { key: 'constitution', abbr: 'COS' },
  { key: 'intelligence', abbr: 'INT' },
  { key: 'wisdom', abbr: 'SAG' },
  { key: 'charisma', abbr: 'CAR' },
];

/** D&D ability score grid (FOR/DES/COS/INT/SAG/CAR) with modifiers. */
export function StatBlock({ abilities }: StatBlockProps) {
  return (
    <div className={styles.grid}>
      {ORDER.map(({ key, abbr }) => {
        const score = Number(abilities?.[key] ?? 10);
        return (
          <div key={abbr} className={styles.stat}>
            <span className={styles.abbr}>{abbr}</span>
            <span className={styles.score}>{score}</span>
            <span className={styles.mod}>{modStr(abilityMod(score))}</span>
          </div>
        );
      })}
    </div>
  );
}
